<template>
  <el-row>
    <el-col :span="8">
      <h6>Max Eligible Amount</h6>
    </el-col>
    <el-col :span="4" :offset="12" class="text-right">
      {{ maxEligibleAmount | currency }}
    </el-col>
  </el-row>
</template>

<script>
import {currency} from '../../../../filters';

export default {
  name: 'OrderUpdatePaymentMaxEligible',
  filters: {
    currency,
  },
  props: {
    maxEligibleAmount: {
      type: Number,
      required: true,
    },
  },
};
</script>
